var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150.9938720703125px",
    height: "242px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "174.50306396484376 -46 150.9938720703125 242",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing-gradow-gradient",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6600ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "editing-gradow-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceAlpha",
    in: "flood",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4,
    in: "SourceGraphic",
    result: "offset-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "shadow",
    result: "offset-2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-gradow-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.64661741256714, 123.85999870300293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72-87.22L6.72-87.22L6.72-87.22Q13.30-94.92 24.22-94.92L24.22-94.92L24.22-94.92Q32.90-94.92 37.52-91.56L37.52-91.56L37.52-91.56Q42.14-88.06 45.22-79.52L45.22-79.52L51.10-62.86L72.24-92.26L91.14-92.26L56.84-46.76L65.66-21.84L65.66-21.84Q67.62-16.24 71.05-12.11L71.05-12.11L71.05-12.11Q74.48-7.98 77.56-7.28L77.56-7.28L77.56-7.28Q74.76-1.96 69.93 0.42L69.93 0.42L69.93 0.42Q65.10 2.80 58.03 2.80L58.03 2.80L58.03 2.80Q50.96 2.80 45.99-1.82L45.99-1.82L45.99-1.82Q41.02-6.44 37.24-16.80L37.24-16.80L33.18-28.00L12.04 0L-5.18 0L27.02-44.66L16.94-72.80L16.94-72.80Q14.70-78.96 12.46-82.11L12.46-82.11L12.46-82.11Q10.22-85.26 6.72-87.22Z",
    fill: "url(#editing-gradow-gradient)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.74ba27be02fcaecd813ed0bd1c68c154.svg";
export { ForwardRef as ReactComponent };